import axios from 'axios'
import { actions as AuthActions } from '../store/slices/AuthSlice'
import { addMinutes } from './timeUtils'

export const setupExpirationCheck = (dispatch, getState) => {
    const currentRole = getState()?.AuthSlice?.role
    if (currentRole === 'guest' || currentRole === undefined) {
        dispatch(AuthActions.setExpirationCheckID(0))
        dispatch(AuthActions.setExpirationCheckTime(''))
        return
    }

    const envSettingInterval = parseInt(
        process.env.MIX_EXPIRATION_CHECK_INTERVAL,
        10,
    )
    const oneDay = 1440 // in minutes
    const twentyDays = 28800 // in minutes
    const intervalMinutes = isNaN(envSettingInterval)
        ? oneDay
        : envSettingInterval <= twentyDays
        ? envSettingInterval
        : twentyDays

    const now = new Date()
    const nextIntervalDate = addMinutes(intervalMinutes, now)
    const checkTimestamp = getState()?.AuthSlice?.expirationCheckTime
    const checkDate = checkTimestamp
        ? new Date(checkTimestamp)
        : nextIntervalDate

    if (checkDate > nextIntervalDate) {
        const newCheckId = setTimeout(
            () => setupExpirationCheck(dispatch, getState),
            intervalMinutes * 60 * 1000,
        )
        dispatch(AuthActions.setExpirationCheckID(newCheckId))
    } else {
        const checkSessionExpiration = () => {
            axios.get('/ajax/me')
        }
        const checkTime = Math.abs(checkDate - now) + 100
        const newCheckId = setTimeout(checkSessionExpiration, checkTime)
        dispatch(AuthActions.setExpirationCheckID(newCheckId))
    }
}

export const setupNewExpirationCheck = (dispatch, getState) => {
    const currentCheckId = getState()?.AuthSlice?.expirationCheckId
    if (currentCheckId !== 0 && currentCheckId !== undefined) {
        clearInterval(currentCheckId)
    }

    const currentRole = getState()?.AuthSlice?.role
    if (currentRole === 'guest' || currentRole === undefined) {
        dispatch(AuthActions.setExpirationCheckID(0))
        dispatch(AuthActions.setExpirationCheckTime(''))
        return
    }

    const envSettingMinutes = parseInt(
        process.env.MIX_EXPIRATION_CHECK_TIME,
        10,
    )
    const twentyFourHours = 1440 // in minutes
    const checkMinutes = !isNaN(envSettingMinutes)
        ? envSettingMinutes
        : twentyFourHours
    const checkDate = addMinutes(checkMinutes, new Date()).toISOString()
    dispatch(AuthActions.setExpirationCheckTime(checkDate))
    setupExpirationCheck(dispatch, getState)
}
